import React from 'react';
import { TypographyText, Col } from 'components/UI/atoms';
import { TableCell } from 'components/UI/atoms/table/TableCell';

const ScaleTd = ({ symptom }: { symptom: any }) => {
  // 실제로 응답이 있는지 확인 (value가 null, undefined, 빈 문자열이 아닌 경우)
  const hasResponse = symptom?.value !== null && symptom?.value !== undefined && symptom?.value !== '';

  // Scale 값이 있는 경우
  if (symptom?.value?.scale >= 0) {
    return (
      <TableCell
        style={{
          borderRight: 'none',
          paddingLeft: 0,
          paddingRight: 0,
        }}
      >
        <Col
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            columnGap: '0.5rem',
          }}
        >
          <img
            src={`${process.env.PUBLIC_URL}/img/survey_icon_${symptom.value.scale}.webp`}
            style={{ width: '1.2rem' }}
            alt={`${symptom.code}${symptom.value.scale}`}
          />
          <TypographyText yjTypeTypographyText="symptom-table-body">{symptom.value.scale}</TypographyText>
        </Col>
      </TableCell>
    );
  }
  // 다른 타입의 응답이 있는 경우 (onset, text, radio, check 등)
  else if (hasResponse) {
    return (
      <TableCell
        style={{
          borderRight: 'none',
          paddingLeft: 0,
          paddingRight: 0,
        }}
      />
    );
  }
  // 실제로 응답하지 않은 경우
  else {
    return (
      <TableCell
        style={{
          borderRight: 'none',
          paddingLeft: 0,
          paddingRight: 0,
        }}
      >
        <Col
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <TypographyText yjTypeTypographyText="symptom-table-body" color="#999999">
            증상 없음
          </TypographyText>
        </Col>
      </TableCell>
    );
  }
};

export default React.memo(ScaleTd);
